import * as React from 'react';

import Lock16 from './Lock16';

export const lock16 = () => <Lock16 />;

export default {
    title: 'Icon|Fill|Lock16',
    component: Lock16,
    parameters: {
        notes: "`import Lock16 from 'box-ui-elements/es/icon/fill/Lock16';`",
    },
};
